import React from 'react'
import cx from 'classnames'
import { MENU_ITEMS } from 'constants/menu'
import { UrlIdpRedirect } from 'helpers/redirects'
import DropdownContainer, { ToggleDropdown } from 'components/layout/DropdownContainer'
import AccountMenu from 'components/layout/AccountMenu'
import { RequestFreeTrialButton } from 'components/ReusableButtons'
import Icon from 'components/shared/Icon'
import { URL_TEAMS, URL_FREE_TRIAL } from 'constants/links'

const dropdownItems = MENU_ITEMS.filter(item => item.position === 'solution')

const DesktopLinks = ({ className, flavour, aol, isLogged, isExternalAuth }) => (
  <div className={className}>
    <ul className='flex items-center pa0 list-reset mv0 f5'>
      {!isLogged && (
        <>
          <li className='mr6'>
            <RequestFreeTrialButton buttonText='Free Trial' className='ph3' />
          </li>
          <li className='mr6'>
            <ToggleDropdown dropdownId='solutions-dropdown'>
              <div className='flex relative pointer'>
                Solutions
                <Icon name='icon-menu-down' className='w7' />
                <DropdownContainer id='solutions-dropdown' className='z35 absolute center-h top7 bg-white shadow-black-1 w13'>
                  <ul className='flex flex-column items-center list-reset pa0'>
                    {dropdownItems.map((item, index) => (
                      <li key={index} className={cx('w-100 hover-bg-ghost-grey flex', { bb: index < dropdownItems.length - 1 })}>
                        <a className='pl6 pv5 no-underline black grow-1' href={item.url}>
                          {item.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </DropdownContainer>
              </div>
            </ToggleDropdown>
          </li>
          <li>
            <a
              className='no-underline normal hover-underline black'
              href={UrlIdpRedirect()}
            >
              Sign in
            </a>
          </li>
        </>
      )}
      {isLogged && (
        <>
          <li className='mr6'>
            <a
              className='no-underline normal hover-underline black'
              href={URL_TEAMS}
            >
              Team
            </a>
          </li>
          <li className='mr6'>
            <a
              className='no-underline normal hover-underline black'
              href={URL_FREE_TRIAL}
            >
              Contact
            </a>
          </li>
        </>
      )}
    </ul>
    {isLogged && <AccountMenu {...{ isExternalAuth, isLogged, flavour, aol }} />}
  </div>
)

export default DesktopLinks
